import { Navigate, Outlet } from "react-router-dom";
import { shouldRedirectToLogin, getDecodedToken, clearAuthTokens } from "utils/tokenUtils";

const CAREERS_APP_URL = process.env.REACT_APP_CAREERS_URL || "https://talent.routes-app.com";

export const PrivateRoute = () => {
  if (shouldRedirectToLogin()) {
    return <Navigate to="/auth/login" />;
  }

  const decoded = getDecodedToken();
  if (decoded?.role === "sponsor") {
    clearAuthTokens();
    window.location.href = CAREERS_APP_URL;
    return null;
  }

  return <Outlet />;
};
